import { useEffect } from 'react'
import { useAtom } from 'jotai'
import { paymentListAtom, listIndexAtom, purchaseTypeAtom, monthlyCoursesAtom, monthlyCourseIdAtom } from '@!/atoms/paymentAtom'

export function usePaymentValidation() {
  const [purchaseType] = useAtom(purchaseTypeAtom)
  const [listIndex] = useAtom(listIndexAtom)
  const [paymentList] = useAtom(paymentListAtom)
  const [monthlyCourses] = useAtom(monthlyCoursesAtom)
  const [monthlyCourseId] = useAtom(monthlyCourseIdAtom)

  useEffect(() => {
    // initPayment()によるatomの初期化や、
    // 直接画面遷移、ブラウザのリロードなどにより、atomの値が不整合状態になる場合のリダイレクト処理
    // purchaseTypeが未設定(null)
    // コイン購入の場合: listIndexが未選択(-1)、またはリストの範囲外の場合
    // 月額コースの場合: monthlyCourseIdが未選択(null)、またはリストに存在しない場合
    const isInvalidState =
      !purchaseType ||
      (purchaseType === 'coin' && (listIndex < 0 || listIndex >= paymentList.length)) ||
      (purchaseType === 'monthly' && (!monthlyCourseId || !monthlyCourses.some((course) => course.id === monthlyCourseId)))

    if (isInvalidState) {
      window.location.href = '/user/payment'
    }
  }, [purchaseType, listIndex, paymentList, monthlyCourses, monthlyCourseId])
}
